export const lc93PublicHomeAssets = {
  heroCleanPlate: {
    id: "LC93-V3-PUBLIC-HOME-HERO-CLEAN-PLATE-A",
    url: "/canonical-assets/lc93/v3/public-home/hero-clean-plate-a.png",
    width: 1024,
    height: 405,
    sha256: "c7dae99bf8a058a45bcd2e5426ab6a0979eac8694baac60c10d9cb6ca1d4350c",
    role: "deterministic-clean-plate",
  },
  navigationEucalyptus: {
    id: "LC93-V3-PUBLIC-HEADER-EUCALYPTUS-EXACT-CROP",
    url: "/canonical-assets/lc93/v3/public-home/nav-eucalyptus-exact-crop.png",
    width: 205,
    height: 52,
    sha256: "14ad946c8d949acbea0daa059af908b61f6627a49359b5cb02686f4c6a734c1e",
    role: "exact-source-crop",
  },
  startingIcons: {
    botanical: {
      id: "LC93-V3-STARTING-BOTANICAL-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/starting-botanical-exact-crop.png",
      width: 42,
      height: 42,
      sha256: "24446e22055fea2d85c2a5212ecd1418c8d4de957fde9dfb63c6a1ebd2f801d6",
      role: "exact-source-crop",
    },
    family: {
      id: "LC93-V3-STARTING-FAMILY-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/starting-family-exact-crop.png",
      width: 50,
      height: 50,
      sha256: "80cf2935284172737281ca239f60b89833cca878f3818460a3ab456c9a9f43b8",
      role: "exact-source-crop",
    },
    photograph: {
      id: "LC93-V3-STARTING-PHOTOGRAPH-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/starting-photograph-exact-crop.png",
      width: 50,
      height: 50,
      sha256: "c9edc860735b57c5c6b1d6856ff1c9957a4d846dfab184584fbbd3e667af8bd5",
      role: "exact-source-crop",
    },
    gift: {
      id: "LC93-V3-STARTING-GIFT-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/starting-gift-exact-crop.png",
      width: 50,
      height: 50,
      sha256: "a428d213917bbba723235d79dc4af41655a6c4f459d016a621d653045918928d",
      role: "exact-source-crop",
    },
  },
  ourStoryPair: {
    id: "LC93-V3-OUR-STORY-PAIR-EXACT-CROP",
    url: "/canonical-assets/lc93/v3/public-home/our-story-pair-exact-crop.png",
    width: 270,
    height: 192,
    sha256: "941fb599066394dc35d3ca51b88dde813c64c7dc1ecf658c9f387e57f349f82a",
    role: "exact-source-crop",
  },
  memoryArrowCallout: {
    id: "LC93-V3-MEMORY-ARROW-CALLOUT-EXACT-CROP",
    url: "/canonical-assets/lc93/v3/public-home/memory-arrow-callout-exact-crop.png",
    width: 255,
    height: 115,
    sha256: "7168adfd46dc41f157a89a0c5077fa5c289a00757f99d113e0f54a27a7ba2277",
    role: "exact-source-crop",
  },
  familyEucalyptusNote: {
    id: "LC93-V3-FAMILY-EUCALYPTUS-NOTE-EXACT-CROP",
    url: "/canonical-assets/lc93/v3/public-home/family-eucalyptus-note-exact-crop.png",
    width: 129,
    height: 220,
    sha256: "dda514a825e7b822fd088c7469d4d116e70cf5e845112672b174260b81250fe0",
    role: "exact-source-crop",
  },
  familyAvatars: {
    maya: {
      id: "LC93-V3-FAMILY-AVATAR-MAYA",
      url: "/canonical-assets/lc93/v3/public-home/avatars/maya.png",
      width: 35,
      height: 35,
      sha256: "623fbd583bc7177ed466f606584a7c368edda53a4b90e73013ce6b89b35dbabc",
      role: "exact-transparent-extraction",
    },
    auntElena: {
      id: "LC93-V3-FAMILY-AVATAR-AUNT-ELENA",
      url: "/canonical-assets/lc93/v3/public-home/avatars/aunt-elena.png",
      width: 35,
      height: 35,
      sha256: "8dd4291b9713edd7bfc40fd85019dba528afe788a6e86c9bfe52bdb921b2bfe5",
      role: "exact-transparent-extraction",
    },
    sam: {
      id: "LC93-V3-FAMILY-AVATAR-SAM",
      url: "/canonical-assets/lc93/v3/public-home/avatars/sam.png",
      width: 34,
      height: 34,
      sha256: "4d6d3fee330524a98147852ff90c7c6724ec0a4492e2dae2e4b858d9f2931118",
      role: "exact-transparent-extraction",
    },
    mom: {
      id: "LC93-V3-FAMILY-AVATAR-MOM",
      url: "/canonical-assets/lc93/v3/public-home/avatars/mom.png",
      width: 34,
      height: 34,
      sha256: "796355bb1215ccb5816f03501d0b5e2d9f8d2eb933b8be0a122a840ae1075f07",
      role: "exact-transparent-extraction",
    },
  },
  trustIcons: {
    lock: {
      id: "LC93-V3-TRUST-LOCK-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/trust-lock-exact-crop.png",
      width: 36,
      height: 36,
      sha256: "fb6cecb7bf2c4e54071d5a1afdec30a93c1eba5b852c932b59cca4f4323ff068",
      role: "exact-source-crop",
    },
    review: {
      id: "LC93-V3-TRUST-REVIEW-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/trust-review-exact-crop.png",
      width: 36,
      height: 36,
      sha256: "77117cb79fd4e263b780ad8ad3ad8f753f6d08a897de010b7abe30ae433cfc24",
      role: "exact-source-crop",
    },
    delete: {
      id: "LC93-V3-TRUST-DELETE-EXACT-CROP",
      url: "/canonical-assets/lc93/v3/public-home/icons/trust-delete-exact-crop.png",
      width: 36,
      height: 36,
      sha256: "3323417ecf4e50f5016756f5bdb7f2a6b5f356d40a2d299837cd8e8302de4f13",
      role: "exact-source-crop",
    },
  },
} as const;
